"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var _0_2_0_3_1 = require("./0.2-0.3");
exports.upgradeMobiledoc02 = _0_2_0_3_1.default;
exports.default = (function (mobiledoc) {
    return utils_1.semverMatchesMinor('0.2')(mobiledoc.version)
        ? _0_2_0_3_1.default(mobiledoc)
        : mobiledoc;
});
